import { React } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import logo from "./logo.png";

export default function Auth() {
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            style={{
                textAlign: "center",
                minWidth: "fit-content",
            }}
        >
            <Grid item xs={12}>
                <Paper
                    style={{
                        backgroundColor: "#01314D",
                    }}
                >
                    <img
                        alt="login"
                        src={logo}
                        style={{
                            marginTop: "20px",
                        }}
                    />
                    <Typography
                        variant="h5"
                        style={{
                            color: "#CC7E3B",
                        }}
                    >
                        Colour your world
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Outlet />
            </Grid>
        </Grid>
    );
}
